import React from "react";
import {
  Col,
  Row,
  Label,
} from "reactstrap";

import ActionDetailCard from './ActionDetailCard';

export default function ActionsList({
  eventActions,
  eventSchedules,
  guestGroups,
  openEditAction,
  openCopyAction,
  openDialogDeleteAction,
  getTypeText,
  setModalLogControl,
}) {

  if (eventActions.length <= 0) {
    return (
      <div style={{ paddingBottom: '10px' }}>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <div>
              <Label htmlFor="formFile" className="form-label">
                {`Não há ações cadastradas`}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
  return (
    <div style={{ paddingBottom: '10px' }}>
      {eventActions.map(a => {
        return (
          <div key={a.id}>
            <ActionDetailCard
              action={a}
              eventSchedules={eventSchedules}
              guestGroups={guestGroups}
              getTypeText={getTypeText}
              openEditAction={openEditAction}
              openCopyAction={openCopyAction}
              openDialogDeleteAction={openDialogDeleteAction}
              setModalLogControl={setModalLogControl}
            />
          </div>
        )
      })}
    </div>
  )
}
